import { render, staticRenderFns } from "./SimpleGreaterThan.vue?vue&type=template&id=70bde595&"
import script from "./SimpleGreaterThan.vue?vue&type=script&lang=ts&"
export * from "./SimpleGreaterThan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports